<!-- src/components/Main.vue -->
<template>
    <el-container class="main-container">
        <!-- 全屏水印层（独立于 layout 结构） -->
        <div class="watermark-layer" v-if="user.Username">
            <div v-for="(row, rowIndex) in rows" :key="'row-' + rowIndex">
                <div v-for="(col, colIndex) in cols" :key="'col-' + colIndex" class="watermark-text" :style="{
                    top: `${rowIndex * rowGap}px`,
                    left: `${colIndex * colGap}px`
                }">
                    {{ user.Username }}
                </div>
            </div>
        </div>
        <!-- 左边导航栏 -->
        <el-aside width="220px" class="sidebar">
            <div class="logo-area">
                <img class="logo-icon" :src="productInfo.avatar || require('@/assets/default-logo.png')" alt="" />
                <h1 class="logo-text">{{ productInfo.name || '企业认证中心' }} </h1>
            </div>
            <el-menu :default-active="activeMenu" class="menu" background-color="transparent" text-color="#666"
                active-text-color="#1473E6" router>
                <template v-for="route in groupedMenu">
                    <el-submenu v-if="route.children" :index="route.meta.title" :key="route.meta.title">
                        <template #title>
                            <span class="menu-text">{{ route.meta.title }}</span>
                        </template>
                        <el-menu-item v-for="sub in route.children" :key="sub.path" :index="'/dashboard/' + sub.path"
                            class="menu-item">
                            <span class="menu-text">{{ sub.meta.title }}</span>
                        </el-menu-item>
                    </el-submenu>
                    <el-menu-item v-else :key="route.path" :index="'/dashboard/' + route.path" class="menu-item">
                        <span class="menu-text">{{ route.meta.title }}</span>
                    </el-menu-item>
                </template>
            </el-menu>
        </el-aside>

        <!-- 主内容区域 -->
        <el-main class="main-content">
            <div class="content-wrapper">
                <router-view />
            </div>
        </el-main>
    </el-container>
</template>

<script>
import { allDynamicRoutes } from '@/router'
import axios, { authBaseURL } from '@/utils/axios'
import productInfo from '@/utils/product_info'

export default {
    name: 'Dashboard',
    data() {
        return {
            productInfo: {},
            activeMenu: '',
            user: {},
            rowGap: 150,
            colGap: 300,
            rows: 0,
            cols: 0
        }
    },
    computed: {
        visibleMenuRoutes() {
            const allowed = this.$store.getters.permissions
            return allDynamicRoutes.filter(route => allowed.includes(route.path))
        },
        groupedMenu() {
            const base = this.visibleMenuRoutes
            // 分组逻辑：将个人中心相关的路由分组到一个子菜单中
            const personalGroup = ['profile', 'change-password', 'logout']
            const personalItems = base.filter(r => personalGroup.includes(r.path))
            // const others = base.filter(r => !personalGroup.includes(r.path))

            const studioGroup = ['my-studios', 'studio-create', 'studio-detail', 'studio-users', 'studio-invite', 'studio-join', 'studio-admin-list','studio-create-admin']
            const studioItems = base.filter(r => studioGroup.includes(r.path))
            
            const sysGroup = ['policies', 'system-users']
            const sysItems = base.filter(r => sysGroup.includes(r.path))

            const others = base.filter(r => !personalGroup.includes(r.path) && !studioGroup.includes(r.path) && !sysGroup.includes(r.path))


            if (studioItems.length > 0) {
                others.push({
                    meta: { title: '工作室管理' },
                    children: studioItems
                })
            }

            if (sysItems.length > 0) {
                others.push({
                    meta: { title: '系统管理' },
                    children: sysItems
                })
            }

            
            if (personalItems.length > 0) {
                others.push({
                    meta: { title: '个人中心' },
                    children: personalItems
                })
            }
            return others
        }
    },
    watch: {
        $route(to) {
            this.activeMenu = to.path
        }
    },
    methods: {
        // 获取产品信息
        async fetchProductInfo() {
            try {
                const res = await axios.get(`${authBaseURL}/api/v1/products/info`, {
                    params: { product_code: productInfo.ProductCode }
                })
                if (res.data.code === 1) {
                    this.productInfo = res.data.data
                }
            } catch (error) {
                console.error('获取产品信息失败:', error)
            }
        },
        updateGrid() {
            this.cols = Math.ceil(window.innerWidth / this.colGap)
            this.rows = Math.ceil(window.innerHeight / this.rowGap)
        },

        async fetchUserData() {
            try {
                const response = await axios.get(authBaseURL + '/api/v1/users/me');
                if (response.data.code === 1) {
                    this.userData = response.data.data;
                    localStorage.setItem('userData', JSON.stringify(response.data.data));
                    return response.data.data;
                } else {
                    console.error('获取用户信息失败:', response.data.message);
                    throw new Error(response.data.message);
                }
            } catch (error) {
                console.error('请求用户数据时出错:', error);
                throw error;
            }
        },
    },
    mounted() {

        this.fetchProductInfo();

        this.fetchUserData();

        const savedData = localStorage.getItem('userData')
        if (savedData) {
            this.user = JSON.parse(savedData)
            console.log('用户数据:', this.user)
        }

        // 计算可以铺多少行和列
        this.cols = Math.ceil(window.innerWidth / this.colGap)
        this.rows = Math.ceil(window.innerHeight / this.rowGap)

        // 可选：监听窗口大小变化，动态调整
        window.addEventListener('resize', this.updateGrid)

        this.activeMenu = this.$route.path
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateGrid)
    }
}
</script>

<style scoped>
.main-container {
    height: calc(100vh - 31px);
    background-color: #f5f5f5;
}

.sidebar {
    background-color: white;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.05);
    transition: all 0.3s;
}

.logo-area {
    display: flex;
    align-items: center;
    padding: 20px 16px;
    border-bottom: 1px solid #e1e1e1;
}

.logo-icon {
    width: 32px;
    height: 32px;
    margin-right: 12px;
}

.logo-text {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2c2c2c;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.menu {
    border-right: none;
    padding: 16px 0;
}

.menu-item {
    height: 48px;
    line-height: 48px;
    margin: 4px 12px;
    border-radius: 8px;
    transition: all 0.3s;
}

.menu-item:hover {
    background-color: #f0f7ff !important;
}

.menu-item.is-active {
    background-color: #f0f7ff !important;
}

.menu-icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    vertical-align: middle;
}

.menu-text {
    vertical-align: middle;
    font-size: 0.95rem;
}

.main-content {
    padding: 24px;
    background-color: #f5f5f5;
    
}

.content-wrapper {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    padding: 10px;
    transition: all 0.3s;
}

.content-wrapper:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}


.watermark-layer {
    pointer-events: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.watermark-text {
    position: absolute;
    color: rgba(0, 0, 0, 0.1);
    font-size: 18px;
    transform: rotate(-30deg);
    user-select: none;
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue